import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import "./app-logo.m.css";
import { useDispatch, useSelector } from "react-redux";
import { RESET_ALL_RADIO_PLAYERS } from "../../store/actions";

const AppLogo = ({ isUserLoginPage = false }) => {
  const dispatch = useDispatch();
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const cdnImage = get(qtState, ["config", "cdn-name"], "");
  const imageKey = get(qtState, ["config", "publisher-settings", "publisher-logo", "temp-image-key"], "");
  const logoUrlFromSettings = get(qtState, ["config", "publisher-settings", "publisher-logo", "url"], "");
  const logoUrlFromPublisher = get(qtState, ["config", "publisher-attributes", "logo_url"], "");

  const finalLogo = logoUrlFromPublisher || logoUrlFromSettings || (cdnImage && imageKey ? `${cdnImage}${imageKey}` : "");
  let homepageSlug = "";
  const currentPath = get(qtState, ["currentPath"], "");
  if (currentPath.startsWith("/lammas")) {
    homepageSlug = "/";
  } else {
    homepageSlug = "/";
  }

  return (
    <Link
      href={homepageSlug}
      aria-label="Etusivulle"
      onClick={() => {
        dispatch({ type: RESET_ALL_RADIO_PLAYERS });
      }}
    >
      <img
        src={finalLogo}
        alt="app-logo"
        styleName={isUserLoginPage ? "publisher-logo-header-small" : "publisher-logo-header"}
        className="app-logo"
        width="87"
        height="55"
      />
    </Link>
  );
};

export { AppLogo };
